import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Question } from 'src/app/_models/question';
import { environment } from '../../environments/environment';
import { AnswerToMark } from '../_models/AnswerToMark';
import { QuizEnvelop } from '../_models/quizEnvelop';
import { AuthHeader } from './../_models/headers';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';

@Injectable({
  providedIn: 'root'
})
export class QuizService {
  aHeader = undefined

  public quizEnvelopSubject: BehaviorSubject<QuizEnvelop> = new BehaviorSubject<QuizEnvelop>(new QuizEnvelop());
  public quizEnvelopObservable=this.quizEnvelopSubject.asObservable


  constructor(private http: HttpClient,private dataUtilService:DataUtilService, private tss:AuthService) {
    this.aHeader = new AuthHeader(tss)
  }

  updateQuizAreaItem(quizAreaItemId: number, topicSubTopicId:number, category:string) {
    let url=`${environment.apiUrl}/quiz/changeQuizAreaStatus/${quizAreaItemId}/${topicSubTopicId}/${category}`
    return this.http.get<any>(url,this.aHeader.bearerJsonHeaders)
    .pipe(map(
      value=>{
        if(this.dataUtilService.isGoodResponse(value)){
          return this.dataUtilService.myData(value)
        }else{
          return {}
        }
      }
    ))
  }
  updateGroupingQuizAreaItem(subscriptionGroupingId: number, topicSubTopicId:number, category:string) {
    let url=`${environment.apiUrl}/subscriptionGrouping/changeQuizAreaItem/${subscriptionGroupingId}?topicSubTopicId=${topicSubTopicId}&categoryName=${category}`
    return this.http.get<any>(url,this.aHeader.bearerJsonHeaders)
    .pipe(map(
      value=>{
        if(this.dataUtilService.isGoodResponse(value)){
          return this.dataUtilService.myData(value)
        }else{
          return {}
        }
      }
    ))
  }

  createTaskVariant(formData:FormData){
    let url=`${environment.apiUrl}/taskTemplate/apicreatevariant`
    return this.http.post<any>(url, formData,this.aHeader.bearerFormHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
         return this.dataUtilService.myData(x)
        }else{
          return {}
      }
    }))
  }
  createTaskTemplate(formData:HttpParams){
    let url=`${environment.apiUrl}/taskTemplate/apicreatetemplate`
    let dd = formData.toString()

    return this.http.post<any>(url, formData,this.aHeader.bearerFormHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
         return this.dataUtilService.myData(x)
        }else{
          return {}
      }
    }))
  }
  createQuiz(subscriptionId:number,quiz_mode_name:string){
    return this.http.post<any>(`${environment.apiUrl}/quiz/saveQuiz/${subscriptionId}/${quiz_mode_name}`, this.formData(quiz_mode_name),this.aHeader.bearerJsonHeaders).pipe(map(
      x=>{
        return x
      }
    ))
  }
  createGroupingQuiz(subscription_grouping_id:number,quiz_mode_name:string){
    return this.http.post<any>(`${environment.apiUrl}/quiz/saveGroupQuiz/${subscription_grouping_id}/${quiz_mode_name}`, this.formData(quiz_mode_name),this.aHeader.bearerJsonHeaders).pipe(map(
      x=>{
        return x
      }
    ))
  }
  markQuestion(quizEnvelopId:number, questionId:number, answerValue:string,isConfirmSave:boolean){

    let fData=this.formatDataQuestionFormData(answerValue,isConfirmSave,questionId)

    return this.http.post<any>(`${environment.apiUrl}/quiz/markQuestion/${quizEnvelopId}/${questionId}`, fData,this.aHeader.bearerJsonHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
          return this.dataUtilService.myData(x)
        }else{
          return {}
        }

      }
    ))
  }

  markPrompt(quizEnvelopId:number, promptId:number, answerValue:string){

    let fData=this.formatDataPromptFormData(answerValue)

    return this.http.post<any>(`${environment.apiUrl}/quiz/markprompt/${quizEnvelopId}/${promptId}`, fData,this.aHeader.bearerFormHeaders).pipe(map(
      x=>{
        if(this.dataUtilService.isGoodResponse(x)){
          return this.dataUtilService.myData(x)
        }else{
          return {}
        }

      }
    ))
  }

  getQuestionAdmin(questionId:number, quizEnvelopId:number){

    return this.http.get<QuizEnvelop>(`${environment.apiUrl}/question/apishowadmin/${questionId}?quizEnvelopId=${quizEnvelopId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      x=>{
          if(this.dataUtilService.isGoodResponse(x)){
           return this.dataUtilService.myData(x)
          }else{
            return new Question()
          }

      }
    ));
  }
  getQuizMode() {
    return this.http.get<any>(`${environment.apiUrl}/quizmode/index`,this.aHeader.bearerJsonHeaders).pipe(map(
      data=>{
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }else{
          return {}
        }
      }
    ))
  }
  getQuestion(questionId:number, quizEnvelopId:number){

    return this.http.get<QuizEnvelop>(`${environment.apiUrl}/question/apishow/${questionId}?quizEnvelopId=${quizEnvelopId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      x=>{
          let dd=new Question()
          if(this.dataUtilService.isGoodResponse(x)){
            dd =this.dataUtilService.myData(x)
          }
        return dd
      }
    ));
  }
  getQuizEnvelop(quizEnvelopId:number){

    return this.http.get<QuizEnvelop>(`${environment.apiUrl}/quizEnvelop/apiget/${quizEnvelopId}`,this.aHeader.bearerJsonHeaders).pipe(map(
      x=>{
          let dd=new QuizEnvelop()
          if(this.dataUtilService.isGoodResponse(x)){
            dd =this.dataUtilService.myData(x)
           this.quizEnvelopSubject.next(dd)

          }
        return dd
      }
    ));
  }
  deleteQuiz(id:number){
    return this.http.get<number>(`${environment.apiUrl}/quizEnvelop/apidelete/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
      x=>{
          let dd=0
          if(this.dataUtilService.isGoodResponse(x)){
            dd =this.dataUtilService.myData(x)
          }
        return dd
      }
    ));
  }
  formData(quiz_mode_name:string){
     return {quiz_mode_name: quiz_mode_name}
  }

  formatDataQuestionFormData(answerValue:string,isConfirmSave:boolean,id:number){
    let body = new AnswerToMark()
    body.value=answerValue==null ? "" :answerValue;
    body.isConfirmSave=isConfirmSave;
    body.id=id

     return body
  }

  formatDataPromptFormData(answerValue:string){
    let body = new URLSearchParams();
    body.set('value', `${answerValue==null?"":answerValue}`);
     return body.toString()
  }



}
